import { apiSlice } from './apiSlice';

export interface VerifyMfaResponse {
  success: boolean;
  accessToken: string;
  type: string;
  role: {
    id: number;
    name: string;
  };
  transactionCode: string;
  passwordChanged: boolean;
}
export const mfaApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    telegramSetup: builder.mutation<
      { success: boolean; message?: string; code?: string },
      { usernameOrEmail: string; password: string }
    >({
      query: (credentials) => ({
        url: '/telegram/setup',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    mobileSetup: builder.mutation<
      { success?: boolean; message?: string; qrCode?: string; secret?: string },
      { usernameOrEmail: string; password: string }
    >({
      query: (credentials) => ({
        url: '/mfa/setup',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    verifyTelegram: builder.mutation<VerifyMfaResponse, { username: string; token: string }>({
      query: (credentials) => ({
        url: '/auth/telegram/verifytelegram',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    verifyNumber: builder.mutation<VerifyMfaResponse, { username: string; token: string }>({
      query: (credentials) => ({
        url: '/auth/mfa/verifymfa',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    enableMfa: builder.mutation<{ success: boolean; message: string }, { token: string }>({
      query: (credentials) => ({
        url: '/mfa/verify-enable-mfa',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    disableMfa: builder.mutation<{ success: boolean; message: string }, { token: string }>({
      query: (credentials) => ({
        url: '/mfa/verify-disable-mfa',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    disableTelegramMfa: builder.mutation<{ success: boolean; message: string }, { token: string }>({
      query: (credentials) => ({
        url: '/telegram/verify-disable-telegram',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    disableTelegramMfaOtp: builder.mutation<{ success: boolean; message: string }, void>({
      query: () => ({
        url: '/telegram/disable',
        method: 'POST',
      }),
      invalidatesTags: ['Auth'],
    }),
  }),
});

export const {
  useTelegramSetupMutation,
  useMobileSetupMutation,
  useVerifyNumberMutation,
  useVerifyTelegramMutation,
  useEnableMfaMutation,
  useDisableMfaMutation,
  useDisableTelegramMfaMutation,
  useDisableTelegramMfaOtpMutation,
} = mfaApi;
